import { ScrollArea, Typography } from "@atlas/core";
import { useTranslation } from "@atlas/sdk";
import { SUPPORT_SERVICES, type SupportServiceId } from "@modules";
import { useMemo, useState } from "react";
import { SupportServiceDetail, SupportServiceList } from "../components";

export function SupportCenterPage() {
  const { t } = useTranslation();
  const [selectedServiceId, setSelectedServiceId] =
    useState<SupportServiceId>("document_shredding");

  const selectedService = useMemo(
    () =>
      SUPPORT_SERVICES.find((service) => service.id === selectedServiceId) ??
      SUPPORT_SERVICES[0],
    [selectedServiceId],
  );

  return (
    <ScrollArea className="min-h-0 flex-1">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
        <div className="flex flex-col">
          <Typography.H2>
            {t("hub.support.welcome_title", {
              defaultValue: "Welcome to the Support Center",
            })}
          </Typography.H2>
          <Typography.P>
            {t("hub.support.welcome_description", {
              defaultValue:
                "Select a service to connect with the right support team.",
            })}
          </Typography.P>
        </div>

        <div className="grid gap-6 lg:grid-cols-2 lg:items-stretch">
          <SupportServiceList
            selectedServiceId={selectedServiceId}
            onSelect={setSelectedServiceId}
          />
          <SupportServiceDetail service={selectedService} />
        </div>
      </div>
    </ScrollArea>
  );
}
